module.exports = __webpack_public_path__ + "static/41-a00f2eefedba6239404431d22956609f.png";